import { FC, useState } from "react";
import { CouponLotteryBadge } from "../../components/Shipment/CouponLotteryBadge";
import {
  CouponRedeemedAnimation,
  CouponRedeemedValue,
} from "../../components/Shipment/CouponRedeemedAnimation";

/**
 * Temporary dev-only preview for the "Vuelve Tu Envío Premiado" promotion
 * visual assets. Lets Marketing approve the badge + redeemed animation
 * without driving the full Crear Guía flow. Remove after sign-off.
 */
const CouponBadgePreview: FC = () => {
  const [redeemed, setRedeemed] = useState<CouponRedeemedValue>(null);

  return (
    <main className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-3xl mx-auto space-y-8">
        <header>
          <h1 className="text-2xl font-bold text-gray-900">
            Promoción "Vuelve Tu Envío Premiado" — Preview de UI
          </h1>
          <p className="text-sm text-gray-600 mt-2">
            Dos badges (50% y 100%) que aparecen en la lista de items durante
            la creación de la guía cuando hay un cupón disponible. El cupón se
            asigna recién al guardar para evitar condición de carrera entre
            cajas. Modal de premio + animación se mantienen al final.
          </p>
        </header>

        <section className="bg-white rounded-lg shadow p-6 space-y-6">
          <h2 className="text-lg font-semibold text-gray-800">
            Badges durante creación
          </h2>

          <div className="flex flex-col gap-4">
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">
                Cupón 50%
              </p>
              <CouponLotteryBadge couponValue={50} />
            </div>

            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">
                Cupón 100%
              </p>
              <CouponLotteryBadge couponValue={100} />
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">
              En contexto: indicador en la sección de cotización (mock)
            </p>
            <div className="border rounded p-4 space-y-3 bg-gray-50">
              <div className="flex justify-between text-sm text-gray-700">
                <span>Sub total</span>
                <span>$ 14,63</span>
              </div>
              <div className="flex justify-between text-sm text-gray-700">
                <span>IVA</span>
                <span>$ 2,34</span>
              </div>
              <div className="flex justify-between text-sm text-gray-700">
                <span>Ipostel</span>
                <span>$ 0,84</span>
              </div>
              <div className="flex justify-between text-sm font-semibold text-gray-900 border-t pt-2">
                <span>Total de factura</span>
                <span>$ 17,81</span>
              </div>
              <div className="pt-2 flex items-center justify-end">
                <CouponLotteryBadge couponValue={50} />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white rounded-lg shadow p-6 space-y-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Animación de premio redimido (modal final)
          </h2>
          <p className="text-sm text-gray-600">
            Reutiliza los assets existentes:
          </p>
          <ul className="text-sm text-gray-600 list-disc pl-5 space-y-1">
            <li>
              <code className="bg-gray-100 px-1 rounded">
                /video/Coupon50.gif
              </code>
            </li>
            <li>
              <code className="bg-gray-100 px-1 rounded">
                /video/Coupon100.gif
              </code>
            </li>
            <li>
              <code className="bg-gray-100 px-1 rounded">
                /audio/TEALCA Sonido Promoción.mp3
              </code>
            </li>
          </ul>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => setRedeemed(50)}
              className="px-4 py-2 rounded bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
            >
              Disparar premio 50%
            </button>
            <button
              type="button"
              onClick={() => setRedeemed(100)}
              className="px-4 py-2 rounded bg-purple-600 text-white text-sm font-medium hover:bg-purple-700"
            >
              Disparar premio 100%
            </button>
          </div>
        </section>

        <CouponRedeemedAnimation
          couponValue={redeemed}
          onClose={() => setRedeemed(null)}
        />
      </div>
    </main>
  );
};

export default CouponBadgePreview;
